import Vue from 'vue';
import Router from 'vue-router';
import { STORM, STORM_REDIRECT } from '@storm/routes';
import { DEMO, DEMO_REDIRECT } from '@/live-demo/routes';

Vue.use(Router);

let routes = [];

if (!process.env.DEMO) {
  routes = [
    {
      path: '/',
      name: 'app-login',
      component: require('@/global-view/login/').default,
    },
    {
      path: '/splash',
      name: 'splash',
      component: require('@/global-view/splash/').default,
    },
    {
      path: '/admin',
      name: 'admin-dashboard',
      component: require('@/global-view/admin/').default,
      meta: {
        breadcrumb: '',
      },
      children: [
        {
          path: '/websites',
          name: 'admin-websites',
          component: require('@/global-view/admin/websites').default,
          meta: {
            breadcrumb: 'Websites',
            root: 'websites',
          },
          children: [
            {
              path: '/edit-site/:id',
              name: 'admin-edit-site',
              component: require('@/global-view/admin/websites/edit-site').default,
              meta: {
                breadcrumb: 'Edit Site',
                root: 'websites',
              },
            },
          ],
        },
        {
          path: '/sub-users',
          name: 'admin-sub-users',
          component: require('@/global-view/admin/sub-users').default,
          meta: {
            breadcrumb: 'Sub-Users',
            root: 'sub-users',
          },
          children: [],
        },
        {
          path: '/account',
          name: 'admin-account',
          redirect: '/profile',
          component: require('@/global-view/admin/account').default,
          meta: {
            breadcrumb: 'Account',
            root: 'account',
          },
          children: [
            {
              path: '/profile',
              name: 'admin-edit-profile',
              component: require('@/global-view/admin/account/profile').default,
              meta: {
                breadcrumb: 'Profile',
                root: 'account',
              },
            },
            {
              path: '/security',
              name: 'admin-edit-security',
              component: require('@/global-view/admin/account/security').default,
              meta: {
                breadcrumb: 'Security',
                root: 'account',
              },
            },
            {
              path: '/billing',
              name: 'admin-edit-billing',
              component: require('@/global-view/admin/account/billing').default,
              meta: {
                breadcrumb: 'Billing',
                root: 'account',
              },
            },
          ],
        },
        {
          path: '/support',
          name: 'admin-support',
          redirect: '/tickets',
          component: require('@/global-view/admin/support').default,
          meta: {
            breadcrumb: 'Support',
            root: 'support',
          },
          children: [
            {
              path: '/tickets',
              name: 'admin-tickets',
              component: require('@/global-view/admin/support/tickets').default,
              meta: {
                breadcrumb: 'Tickets',
                root: 'support',
              },
              children: [
                {
                  path: '/tickets/view/:id',
                  name: 'admin-tickets-view',
                  component: require('@/global-view/admin/support/tickets/view').default,
                  meta: {
                    breadcrumb: ':id',
                    root: 'support',
                  },
                },
                {
                  path: '/tickets/create',
                  name: 'admin-tickets-create',
                  component: require('@/global-view/admin/support/tickets/create').default,
                  meta: {
                    breadcrumb: 'Create',
                    root: 'support',
                  },
                },
              ],
            },
            {
              path: '/backups',
              name: 'admin-backups',
              component: require('@/global-view/admin/support/backups').default,
              meta: {
                breadcrumb: 'Backups',
                root: 'support',
              },
            },
          ],
        },
        {
          path: '/blocked',
          name: 'blocked',
          component: require('@/global-view/admin/blocked').default,
          meta: {
            breadcrumb: '',
            root: 'blocked',
          },
          children: [],
        },
      ],
    },
    {
      path: '/page-editor',
      name: 'page-editor',
      component: require('@editor/page').default,
      children: [
        {
          path: '/edit-page/:id',
          name: 'edit-page',
          component: require('@editor/page').default,
          meta: {
            breadcrumb: 'Launch Editor',
            root: 'websites',
          },
        },
      ],
    },
  ];
}

let redirect = {
  path: '*',
  redirect: '/websites',
};

if (process.env.ADMIN === 'storm') {
  routes.push(STORM);
  redirect = STORM_REDIRECT;
}

if (process.env.DEMO) {
  routes = [DEMO];
  redirect = DEMO_REDIRECT;
}

routes.push(redirect);

export default new Router({
  mode: 'history',
  routes,
});



// WEBPACK FOOTER //
// ./src/router/index.js